import React from 'react';
import { StandaloneResetPasswordForm } from '@fiverr-private/identification_marketplace';
import { SimpleFormWrapper } from '../shared/SimpleFormWrapper';
import '../shared/styles/Global.ve.css';

export const ResetPassword = () => {
  const onSubmit = () => {
    window.location.assign('/');
  };

  return (
    <SimpleFormWrapper>
      <StandaloneResetPasswordForm
        onSubmit={onSubmit}
        mixpanelEnrichment={{
          funnel: 'standard',
          triggerType: 'User Trigger',
        }}
        bigQueryEnrichment={{
          funnel: 'standard',
          reason: 'user_trigger',
        }}
      />
    </SimpleFormWrapper>
  );
};
